import styled from 'styled-components';

export const Carousel = styled.div`
  @media (max-width: ${props => props.theme.mediaSm}) {
    width: auto;
    iframe {
      height: 300px !important;
    }
  }
`;
